import { useQuery } from '@tanstack/react-query';
import { fetchBanks } from './request';
import { BANKS_QUERY_KEY } from './key';

export const useBanks = () => {
  return useQuery({
    queryKey: [BANKS_QUERY_KEY],
    queryFn: fetchBanks,
  });
};
